export const DEFAULT_LAYER_MASK = 0b00000001; //  1
export const COORDINATE_LAYER_MASK = 0b00000010; //  2
export const UI_LAYER_MASK = 0b00000100; //  4
export const HELPER_LAYER_MASK = 0b00001000; //  8
export const PRODUCT_LAYER_MASK = 0b00010000; // 16
